/*
 * @Author: Ashley.Liu
 * @Date: 2022-02-23 14:48:40
 * @LastEditTime: 2022-06-22 17:58:57
 * @Description: utils
 */
import Loading from '@zoom/zoom-ui/src/components/loading/loading.vue'
import Vue from 'vue'
export * from './historyItems'
export * from './isEmpty'
export * from './uuid'
export * from './setProps'

/**
 * @example messageTimestampType => Message Timestamp Type
 */
export const UpperCaseWithSpace = ([first, ...rest]) => {
  return first.toUpperCase() + rest.join('').replace(/([a-z])(?=[A-Z])/g, '$1 ')
}

export function setTimeWithUTC (timeVal, timeZone) {
    if (!timeVal) return 'null'
    const time = parseInt(timeVal) + timeZone * 60 * 60 * 1000
    return new Date(time).getUTCFullYear() + '-' +
    (new Date(time).getUTCMonth() + 1) + '-' +
    new Date(time).getUTCDate() + ' ' +
    new Date(time).getUTCHours() + ':' +
    new Date(time).getUTCMinutes() + ':' +
    new Date(time).getUTCSeconds()
}

// debounce use in methods like save: debounce(()=>{}, 300)
export function debounce (fn, delay = 500) {
    let timer = null
    return function () {
        if (timer) {
            clearTimeout(timer)
            timer = null
        }
        timer = setTimeout(() => {
            fn.apply(this, arguments)
            timer = null
        }, delay)
    }
  }
/**
 * loading wrapper
 * @param {*} elNode support class name
 * @param {*} asyncFn async function
 * @returns
 */
export function loadingWrapper (elNode, asyncFn) {
    return function () {
      const Mask = Vue.extend(Loading)
      const mask = new Mask({
        el: document.createElement('div'),
        data: {
          fullscreen: false
        }
      })
      const dom = document.body.querySelector(elNode)
      mask.$el.style.display = 'block'
      mask.$el.classList.add('my-defult-loading')
      dom && dom.appendChild(mask.$el)
      asyncFn.apply(this).then(() => {
        dom && dom.removeChild(mask.$el)
      }).catch(() => {
        dom && dom.removeChild(mask.$el)
      })
    }
  }

export const tokenUtil = {
  getToken () {
    return localStorage.getItem('token')
  },
  getRefreshToken () {
    return localStorage.getItem('refreshToken')
  },
  getCubeToken () {
    return localStorage.getItem('cubeToken')
  },
  set (token, keyType = 'token') {
    if (token) {
      const tokenInfo = this.parsaeToken(token)
      const timeOffset = Math.floor(new Date().getTime() / 1000) - tokenInfo.iat
      if (keyType === 'cubeToken') {
        localStorage.setItem('cubeTimeOffset', timeOffset)
      } else {
        localStorage.setItem('timeOffset', timeOffset)
      }
    }
    localStorage.setItem(keyType, token)
  },
  validateTokenExp (token, isCube) {
    if (!token) {
      return false
    }
    let timeOffset = localStorage.getItem('timeOffset')
    if (isCube)timeOffset = localStorage.getItem('cubeTimeOffset')
    const tokenInfo = this.parsaeToken(token)
    if (!tokenInfo) return false
    const timeInterval = Math.floor(new Date().getTime() / 1000) - tokenInfo.iat - (timeOffset || 0)
    if (timeInterval + 2 * 60 > tokenInfo.exp - tokenInfo.iat) {
      return false
    }
    return true
  },
  parsaeToken (token) {
    if (!token.includes('.')) return
    const userInfo = JSON.parse(decodeURIComponent(encodeURIComponent(window.atob(token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')))))
    return userInfo
  }
}
